module.exports = __webpack_public_path__ + "3383e0edd82459420d1f7284d924a84a.svg";